export const meta: BlockMeta = {
  title: "Text CTA",
  tags: ["#page", "#inline"],
}

import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/text-cta", (props) => {
  return (
    <Appear className="content-sized block-spacing relative flex items-center justify-center">
      <InnerBlocks
        className={cn(
          "w-full flex flex-col gap-4 [&_p]:!type-mobile-headings-heading-l [&_p]:md:!type-desktop-headings-heading-l [&_p]:md:max-w-[65%]",
        )}
        allowedBlocks={["core/heading", "core/paragraph", "core/button"]}
        template={[
          ["core/paragraph", { placeholder: "Add text here..." }],
          ["core/button", { text: "Learn More" }],
        ]}
      />
    </Appear>
  )
})
